import SalesAnalysisPreview from "./SalesAnalysisPreview";

const PrintSalesAnalysis: React.FC = () => {
  return (
    <div className="inner-container">
      <SalesAnalysisPreview />
    </div>
  );
};

export default PrintSalesAnalysis;
